import UserSuggestionsList from "../../components/suggestions/UserSuggestionsList"

export const SuggestionsUserPage = () => {

    return (
        <UserSuggestionsList></UserSuggestionsList>
    )
}